import { gsap } from 'gsap';

const animationTiming = {
  duration: 0.4,
  easing: 'power3.out'
};

const closeAnimation = (content, element) => gsap.to(content, {
  height: 0,
  ...animationTiming,
  overwrite: true,
  onComplete: () => {
    element.removeAttribute('open');
  },
});


const openAnimation = content => gsap.fromTo(
  content,
  {
    height: 0,
  },
  {
    height: 'auto',
    ...animationTiming,
    overwrite: true,
  }
);

const init = () => {
  const accordionElements = document.querySelectorAll('.js-accordion');
  const OPEN_CLASS = 'is-open';

  accordionElements.forEach(element => {
    const trigger = element.querySelector('.js-accordion-trigger');
    const target = element.querySelector('.js-accordion-target');

    if (element.classList.contains(OPEN_CLASS)) {
      openAnimation(target).restart();
    } else {
      closeAnimation(target, element).restart();
    }


    const handleClick = (event) => {
      event.preventDefault();
      const isOpen = element.classList.contains(OPEN_CLASS);

      if (isOpen) {
        element.classList.toggle(OPEN_CLASS);
        element.setAttribute('open', 'false');
        closeAnimation(target, element).restart();
      } else {
        element.setAttribute('open', 'true');
        element.classList.toggle(OPEN_CLASS);

        openAnimation(target).restart();
      }
    };

    trigger.addEventListener('click', handleClick);

  });
};

export default init;
